import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class AdverseEventDeclaredJournalEvent extends JournalEvent {
  static override type = "adverse-event-declared-journal-event";

  /**
   * A Parog specific string identifier
   */
  @attr("string") declare adverseEventId: string;

  /**
   * Contains more details when adverse-event-id is `other`.
   */
  @attr("string") declare otherDetails: string;

  /**
   * A EVA score associated with the Adverse Event.
   * It may be null.
   */
  @attr("number") declare evaScore: number;

  static override validations(intl: IntlService) {
    return {
      adverseEventId: validatePresence({
        presence: true,
        description: intl.t(
          "validations.adverse-event-declared-journal-event.adverse-event-id"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.adverse-event-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      evaScore: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.adverse-event-declared-journal-event.evaScore"
        )
      })
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "adverseEventDeclaredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "adverse-event-declared-journal-event": AdverseEventDeclaredJournalEvent;
  }
}
